export default __webpack_public_path__ + "static/media/icon-twitter-white.8b13f688.svg";